import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCat, faDog, faTurtle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetType, PetTypeIds } from '@spike/model';
import clsx from 'clsx';
import styles from 'components/UI/V3/PetTypeIcon/PetTypeIcon.module.scss';
import React from 'react';

interface PetTypeIconProps {
    size?: number;
    type: PetType;
    className?: string;
    variant?: 'regular' | 'light' | 'unstyled';
}

const PET_TYPE_ICONS_MAP: Record<PetTypeIds, IconProp> = {
    [PetTypeIds.DOGS]: faDog,
    [PetTypeIds.CATS]: faCat,
    [PetTypeIds.EXOTICS]: faTurtle
};

export const PetTypeIcon: React.FC<PetTypeIconProps> = ({ size = 32, type, className, variant = 'regular' }) => {
    const typeId = type.id as PetTypeIds;

    return (
        <div
            data-pet-type-id={typeId}
            style={
                {
                    '--size': `${size}px`
                } as React.CSSProperties
            }
            className={clsx(styles.root, className, {
                [styles.light]: variant === 'light',
                [styles.regular]: variant === 'regular',
                [styles.unstyled]: variant === 'unstyled'
            })}
        >
            <FontAwesomeIcon icon={PET_TYPE_ICONS_MAP[typeId]} />
        </div>
    );
};
